

































































import { Component, Prop, Vue } from "vue-property-decorator";
import { IContract } from "@/models/contract.entity";
import { VehicleContractBase } from "@/models/vehicle-contract-base.entity";
import { IReport } from "@/models/report.entity";
import { IClearance } from "@/models/clearance.entity";
import { CurrencyEnum } from "@/lib/enum/currency.enum";
import { ContractTypeEnum } from "@/lib/enum/contract-type.enum";
import { VehicleContractTypeEnum } from "@/lib/enum/vehicle-contract-type.enum";
import { ApprovalLimitChecker } from "@/lib/utility/ApprovalLimitChecker";
import { formatCurrency } from "@/lib/utility/currency-helper";
import { $t } from "@/lib/utility/t";

@Component
export default class ReportClearanceApprovalContractSelectSheet extends Vue {
  @Prop({ required: true }) contract!: IContract | VehicleContractBase;
  @Prop({ type: Boolean, default: false }) value!: boolean;
  @Prop({ type: Boolean, default: false }) disabled!: boolean;
  @Prop() report?: IReport;
  @Prop() clearance?: IClearance;

  ContractTypeEnum = ContractTypeEnum;
  VehicleContractTypeEnum = VehicleContractTypeEnum;
  CurrencyEnum = CurrencyEnum;

  get isSelected(): boolean {
    return this.value;
  }

  set isSelected(val: boolean) {
    this.$emit("input", val);
  }

  get hasCompany(): boolean {
    return !!this.contract.company;
  }

  get companyName(): string {
    return this.contract?.company?.companyName || $t("clearanceApproval.addCompany");
  }

  get contractTypeLabel(): string {
    if ("type" in this.contract) {
      return this.$t(`enums.ContractTypeEnum.${this.contract.type}`) as string;
    }
    if ("contractType" in this.contract) {
      return this.$t(`enums.VehicleContractTypeEnum.${this.contract.contractType}`) as string;
    }
    return "";
  }

  get approvalLimitChecker(): ApprovalLimitChecker {
    return new ApprovalLimitChecker(this.contract, this.report, this.clearance);
  }

  formatCurrency(value: number | undefined, currency: CurrencyEnum = CurrencyEnum.EUR): string {
    if (value === undefined) return "";
    return formatCurrency(value, currency);
  }
}
